import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { UpdateAvailableCurrencyRequestModel } from '@/models/currency/currency.model';

export default class UpdateAvailableCurrencyListRequest extends ApiResourceMethod<{}> {
  public perform(payload: UpdateAvailableCurrencyRequestModel): Promise<{}> {
    return this.performer.requestWithMapper(
      { data: payload },
      (payload: BaseResponse<{}>) => {
        return payload.data;
      },
    );
  }
}
